<div>
  <ft-ppss-card
    *ngFor="let card of cardData; trackBy: trackCards"
    edsSpacing="base"
    [data]="card"
  ></ft-ppss-card>
</div>
